import { Box, Container, CssBaseline } from "@mui/material";
import Carousel from "nuka-carousel";
import React, { useEffect, useState } from "react";
import ContactForm from "./ContactForm";
import { config } from "../../utility/Config";
import { appInfoService } from "../../services/AppInfoService";
import { AuthContext } from "../../utility/context/AuthContext";
import { societiesService } from "../../services/SocietiesService";
import { MWhatsNewsService } from "../../services/MWhatsNewsService";

const Index = () => {
  const [indexHtml, setIndexHtml] = useState('');
  const { auth, setAuth } = React.useContext(AuthContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [features, setfeaturse] = useState([]);

  // useEffect(() => {
  //   if (features.length > 0) {
  //     const interval = setInterval(() => {
  //       setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
  //     }, 11000);
  //     return () => clearInterval(interval);
  //   }
  // }, [features]);
useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) => (prev + 1) % features.length);
  }, 4000); // every 4 seconds
  return () => clearInterval(interval);
}, [features.length]);


  const getSoftwareFeatures = () => {
    MWhatsNewsService.getSoftwareFeatures()
      .then((Response) => {
        let result = Response.data;
        if (result && result.list) {
          setfeaturse(result.list);
        }
      });
  };

  function getAppInfoHtml() {
    appInfoService.getAllHtml().then((response) => {
      if (response) {
        let result = response.data;
        if (result.isSuccess) {
          setIndexHtml(result.row?.HomePageHtml);
          localStorage.setItem('HomePageEmail', result.row.Email ?? '');
          localStorage.setItem('HomePageMobile', result.row.Mobile ?? '');
        }
      }
    });
  }

  useEffect(() => {
    console.log('Index Page called 1');
    societiesService.clearStorageForIndex();
    setAuth(null);
    getSoftwareFeatures();
    if (!indexHtml) getAppInfoHtml();
  }, []);

  // Inline keyframes simulation for animation
  const floatAnimationStyle = {
    animationName: {
      from: { transform: 'translateY(-50%) translateY(0)' },
      '50%': { transform: 'translateY(-50%) translateY(-10px)' },
      to: { transform: 'translateY(-50%) translateY(0)' },
    },
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  };

  return (
    <>
      <CssBaseline />
      <div style={{ position: 'relative', textAlign: 'center', color: 'black' }}>
        <img src="images/banner.png" className="banner-image" alt="" width="100%" height="500px" />

        {/* Center Text (unchanged) */}
        {features.length > 0 && features[currentIndex] && (
          <div
            style={{
              position: 'absolute',
              bottom: '10%',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
            className="slide-text-container"
          >
            <h6 className="slide-text">
              {features[currentIndex].SoftwareFeature}
            </h6>
           
          </div>
        )}


        {/* {features.length > 0 && (
          <div
            key={currentIndex}
            style={{
              position: 'absolute',
              top: '80%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '10px',
              textAlign: 'center',
            }}
            className="slide-text-container"
          >
            <h2 className="slide-text">{features[currentIndex].SoftwareFeature}</h2>
          </div>
        )} */}

        {/* <pre>{JSON.stringify(features, null, 2)}</pre> */}

        {/* Right-Side Animated Text */}
        {features.length > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '40%',
              right: '0',
              transform: 'translateY(-50%)',
              width: '400px',
              height: '200px',
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #f0f4ff, #e9efff)', // soft gradient
              borderRadius: '1px',
              padding: '16px',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)', // soft shadow
              backdropFilter: 'blur(6px)', // optional: blur background behind the box
            }}
          >
            <div className="scroll-container">
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                {features.map((item, index) => (
                  <li key={index} style={{ fontSize: '1rem', marginBottom: '10px', textAlign: 'left' }}>
                    {item.SoftwareFeature}
                  </li>
                ))}
              </ul>

            </div>
          </div>
        )}
      </div>

      <Container>
        <Box>
          <div dangerouslySetInnerHTML={{ __html: indexHtml }} />
        </Box>
      </Container>

      <ContactForm />

      {/* Inline animation injection using <style> */}
      <style>
        {`
          @keyframes floatText {
            0% { transform: translateY(-50%) translateY(0); }
            50% { transform: translateY(-50%) translateY(-10px); }
            100% { transform: translateY(-50%) translateY(0); }
          }
        `}
      </style>
    </>
  );
};

export default Index;
